var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 112,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 112,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC3059",
    d: "M14.09 9.8H9.904L6.992 28h2.626l.494-3.302h3.51L14.116 28h2.886L14.09 9.8Zm-2.262 3.224h.052l1.352 9.204h-2.756l1.352-9.204ZM12.057 36.667l5.276 7.295-5.39 7.371-5.276-7.295 5.39-7.371ZM40.085 45 48 55.943 39.915 67 32 56.057 40.085 45ZM65.91 102.2h4.186L73.008 84h-2.626l-.494 3.302h-3.51L65.884 84h-2.886l2.912 18.2Zm2.262-3.224h-.052l-1.352-9.204h2.756l-1.352 9.204ZM67.943 75.333l-5.276-7.295 5.39-7.371 5.276 7.295-5.39 7.371Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/AD.a575b5a19a46d9819db821da585924ed.svg";
export { ForwardRef as ReactComponent };